import { useContext } from '@nuxtjs/composition-api'

const v3ApiBaseUrl = () =>
  process.env.API_BROWSER_BASE_URL?.replace('/api', '') || ''

// バックグラウンドのトラッキング呼び出しのため、失敗時にグローバルなエラーページ遷移を発生させない
const silentParams = { params: { silent: 1 } }

export default () => {
  const { $axios } = useContext()

  const createA8netAffiliate = (a8Param: string, sessionId: string) =>
    $axios.$post<affiliate.A8netAffiliate>(
      `${v3ApiBaseUrl()}/v3/affiliate/a8net_affiliates`,
      { a8_param: a8Param, session_id: sessionId },
      silentParams
    )

  return { createA8netAffiliate }
}
